import React from 'react'

import { LogoutOutline, SettingsOutline, UserSquare } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool, func } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Account group: admin (admins only), public profile, settings and log out.
function AccountSection({
  locale = 'en',
  isAdmin = false,
  adminUrl = '',
  username = '',
  onLogout,
}) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  function handleLogout(e) {
    e.preventDefault()
    onLogout()
  }

  return (
    <Section divided>
      {isAdmin && (
        <MenuItem
          title={t('navigation.user_menu.dashboard')}
          url={adminUrl}
          dataName="Admin"
        />
      )}
      {username && (
        <MenuItem
          title={t('navigation.user_menu.public_profile')}
          url={`/${username}`}
          svgComponent={UserSquare}
          dataName="Public Profile"
        />
      )}
      <MenuItem
        title={t('navigation.user_menu.settings')}
        url="/profile/settings"
        svgComponent={SettingsOutline}
        dataName="Account Settings"
      />
      <MenuItem
        title={t('navigation.user_menu.logout')}
        url="/users/logout"
        svgComponent={LogoutOutline}
        dataName="Log out"
        dataMethod="delete"
        onClick={handleLogout}
      />
    </Section>
  )
}

AccountSection.propTypes = {
  locale: string,
  isAdmin: bool,
  adminUrl: string,
  username: string,
  onLogout: func.isRequired,
}

export default AccountSection
